import { render } from "./Public.vue?vue&type=template&id=6bf1061e&scoped=true"
import script from "./Public.vue?vue&type=script&lang=js"
export * from "./Public.vue?vue&type=script&lang=js"

import "./Public.vue?vue&type=style&index=0&id=6bf1061e&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf1061e"]])

export default __exports__